import {
    UPDATE_CURRENT_SUB_ZONE,
    LINKS_IN_POLYGONS_RECEIVED,
    GET_LINKS_IN_POLYGON,
    HIGHLIGHT_POLYGON_LINKS,
    SET_POLYGON_FEATURES,
    GET_ALL_PROPOSED_ANALYSIS_ZONES,
    ALL_PROPOSED_ANALYSIS_ZONES_RECEIVED,
    SET_SELECTED_ZONES,
    DELETE_SELECTED_ZONES,
    COPY_SELECTED_ZONES,
    TOGGLE_FORM_VALIDATED,
    CONFIRM_ANALYSIS_ZONE_TOGGLE,
    CREATE_ANALYSIS_ZONE_AND_SUB_ZONES,
    ANALYSIS_ZONE_AND_SUB_ZONES_CREATED,
    GET_ZONE_COMPONENTS,
    ZONE_COMPONENTS_RECEIVED,
    SET_SEGMENT_FEATURES,
    HIGHLIGHT_SEGMENT_LINKS,
    UPDATE_ZONE_FILTERS,
    EDIT_ANALYSIS_ZONE_AND_SUB_ZONES,
    ANALYSIS_ZONE_AND_SUB_ZONES_EDITED,
    DELETE_ZONE_COMPONENTS,
    CLEAR_ZONE_COMPONENTS,
    IS_ANALYSIS_ZONE_CHECKED,
    PROPOSED_ZONE_ID,
    GET_DATA_FOR_ANALYZER_FILTERS,
    DATA_FOR_ANALYZER_FILTERS_RECEIVED,
    SET_ANALYZER_FILTER_PARAMS,
    TOGGLE_ANALYSIS_ZONES_ACTION_PERFORMED
} from "./index";

import { Features } from "components/curb/ManagerAnalyzer/Analyzer/types";
import { HighlightedPolygonLinksInterface } from "components/curb/filter/AnalysisZone";
import { GetResponseInterface } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
import { CurrentUserInterface } from "actions/User/types";
import { GetRequestSingleItemInterface } from "interfaces/ActionReducer/GetMethod/GetRequestSingleItem";
import { ExportFileType } from "actions/regulation/Listview/types";
import { GetRequestInterface } from "../../interfaces/ActionReducer/GetMethod/GetRequest";
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

export const EXPORT_MULTIPLE_ZONES = "EXPORT_MULTIPLE_ZONES";

export interface updateCurrentSubZoneAction {
    type: typeof UPDATE_CURRENT_SUB_ZONE;
    payload: { subZone: string };
}

export interface getLinksInPolygonAction {
    type: typeof GET_LINKS_IN_POLYGON;
    payload: getLinksPolygonInterface;
}

export interface linksInPolygonsReceivedAction {
    type: typeof LINKS_IN_POLYGONS_RECEIVED;
    payload: { response: GetResponseInterface };
}

export interface highlightPolygonLinksAction {
    type: typeof HIGHLIGHT_POLYGON_LINKS;
    payload: {
        links: HighlightedPolygonLinksInterface[];
    };
}

export interface setPolygonFeaturesAction {
    type: typeof SET_POLYGON_FEATURES;
    payload: {
        features: polygonFeatures;
    };
}

export interface getAllProposedAnalysisZonesAction {
    type: typeof GET_ALL_PROPOSED_ANALYSIS_ZONES;
    payload: { params?: GetRequestSingleItemInterface };
}

export interface allProposedAnalysisZonesReceivedAction {
    type: typeof ALL_PROPOSED_ANALYSIS_ZONES_RECEIVED;
    payload: {
        data: GetResponseInterface;
    };
}

export interface setSelectedZonesAction {
    type: typeof SET_SELECTED_ZONES;
    payload: { zoneIds: (number | undefined)[] };
}

export interface deleteSelectedZonesAction {
    type: typeof DELETE_SELECTED_ZONES;
    payload: {
        ids: (number | undefined)[];
    };
}

export interface toggleAnalysisZonesActionPerformedAction {
    type: typeof TOGGLE_ANALYSIS_ZONES_ACTION_PERFORMED;
    payload: { actionPerformed: boolean };
}

export interface copySelectedZonesAction {
    type: typeof COPY_SELECTED_ZONES;
    payload: {
        analysisZoneIds: (number | undefined)[];
    };
}

export interface toggleFormValidatedAction {
    type: typeof TOGGLE_FORM_VALIDATED;
    payload: {
        validated: boolean;
    };
}

export interface confirmAnalysisZoneToggleAction {
    type: typeof CONFIRM_ANALYSIS_ZONE_TOGGLE;
    payload: { toggle: boolean };
}

export interface isAnalysisZoneCheckedAction {
    type: typeof IS_ANALYSIS_ZONE_CHECKED;
    checked: boolean;
}

export interface proposedZoneIdAction {
    type: typeof PROPOSED_ZONE_ID;
    payload: { id: number };
}

export interface createAnalysisZoneAndSubZonesAction {
    type: typeof CREATE_ANALYSIS_ZONE_AND_SUB_ZONES;
    payload: { formData: AnalysisZoneAndSubZonesInterface };
}

export interface analysisZoneAndSubZonesCreatedAction {
    type: typeof ANALYSIS_ZONE_AND_SUB_ZONES_CREATED;
    payload: { response: analysisZoneAndSubZonesCreatedorEditedInterface };
}

export interface getZoneComponentsAction {
    type: typeof GET_ZONE_COMPONENTS;
    payload: { params: getZoneComponentsInterface };
}

export interface zoneComponentsReceivedAction {
    type: typeof ZONE_COMPONENTS_RECEIVED;
    payload: { response: { zoneId: number } | GetResponseInterface };
}

export interface updateZoneFiltersAction {
    type: typeof UPDATE_ZONE_FILTERS;
    payload: {
        zones: Set<number>;
    };
}

export interface editAnalysisZoneAndSubZonesAction {
    type: typeof EDIT_ANALYSIS_ZONE_AND_SUB_ZONES;
    payload: { data: AnalysisZoneAndSubZonesInterface };
}

export interface analysisZoneAndSubZonesEditedAction {
    type: typeof ANALYSIS_ZONE_AND_SUB_ZONES_EDITED;
    payload: { data: analysisZoneAndSubZonesCreatedorEditedInterface };
}

export interface deleteZoneComponentsAction {
    type: typeof DELETE_ZONE_COMPONENTS;
    payload: { data: number[] };
}

export interface clearZoneComponentsAction {
    type: typeof CLEAR_ZONE_COMPONENTS;
}

export interface setSegmentFeaturesAction {
    type: typeof SET_SEGMENT_FEATURES;
    payload: { features: polygonFeatures };
}

export interface highlightSegmentLinksAction {
    type: typeof HIGHLIGHT_SEGMENT_LINKS;
    payload: { links: HighlightedPolygonLinksInterface[] };
}

export interface getAllProposedAnalysisZoness {
    meta: {
        count: number;
        next?: string;
        previous?: string;
    };
    results: {
        id: number;
        component_types: string;
        created: string;
        modified: string;
        name: string;
        description: string;
        show_on_maps: boolean;
        total_spaces: number;
        user: number;
    }[];
}

export interface SegmentFeatures {
    features: Features;
    links: Array<number>;
    spacesCount: number;
    type: string;
    uuid: string;
}

export interface HighlightedSegmentLinks {
    id: number;
}

export interface getZoneComponentsInterface {
    zone__id?: number;
    zone__id__in?: string;
    limit?: string;
    detailed_assets?: boolean;
}
export interface anynewsegements {
    [propname: string]: any;
}

export interface AnalysisZoneAndSubZonesInterface {
    currentUser: CurrentUserInterface | null;
    description: string;
    id?: number;
    segments?: any;
    name: string;
    subZones: polygonFeatures;
}

export interface getLinksPolygonInterface {
    subZone: Features;
}

export interface polygonFeatures {
    [proname: string]: any;
}

export interface GetResponseInterfaceTemplate {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: Array<{ [prop: string]: any }>;
}

export const defaultGetResponseALL = {
    meta: {
        count: 0,
        next: null,
        previous: null
    },
    results: []
};

export interface analysisZoneAndSubZonesCreatedorEditedInterface {
    component_types: string;
    created: string;
    description: string;
    id: number;
    modified: string;
    name: string;
    show_on_maps: boolean;
    total_spaces: number;
}

export const DefaultCreateorEditresponse = {
    component_types: "abc",
    created: "def",
    description: "ghi",
    id: 0,
    modified: "jklm",
    name: "nopq",
    show_on_maps: true,
    total_spaces: 0,
    user: 1
};

export interface polygonLinksInterface {
    [propname: string]: any;
}

export type ZoneIds = (number | undefined)[];
export interface exportMultipleZonesInterface {
    type: typeof EXPORT_MULTIPLE_ZONES;
    payload: {
        zoneIds: ZoneIds;
        fileType: ExportFileType;
        getParams: GetRequestSingleItemInterface;
    };
}

//list view
export interface analyzerListViewFilterParams {
    [index: string]: string | number | string[];
}

export type AnalyzerFilters = Array<{ [prop: string]: any }>;

export interface GetDataForAnalyzerFiltersAction {
    type: typeof GET_DATA_FOR_ANALYZER_FILTERS;
    payload: { params: Partial<GetRequestInterface> };
}

export interface DataForAnalyzerFiltersReceivedAction {
    type: typeof DATA_FOR_ANALYZER_FILTERS_RECEIVED;
    payload: { data: AnalyzerFilters };
}

export interface SetAnalyzerFilterParamsAction {
    type: typeof SET_ANALYZER_FILTER_PARAMS;
    payload: { params: analyzerListViewFilterParams };
}
export interface analyzerDataStateInterface {
    polygonFeatures: polygonFeatures;
    highlightedPolygonLinks: HighlightedPolygonLinksInterface[];
    allProposedAnalysisZones: GetResponseInterface;
    isTableauParamsReceived: boolean;
    isAnalysisZoneAndSubZonesEdited: boolean;
    isZoneComponentsReceived: boolean;
    isAnalysisZoneAndSubZonesCreated: boolean;
    confirmAnalysisZoneToggle: boolean;
    isFormValidated: boolean;
    proposedZoneId: number;
    segmentFeatures: polygonFeatures;
    highlightedSegmentLinks: HighlightedPolygonLinksInterface[];
    isFetchingPolygonLinks: boolean;
    isAllProposedAnalysisZonesFetching: boolean;
    currentSubZone: string | null;
    zoneFilters: Set<number>;
    analysisZoneAndSubZonesEdited: polygonFeatures;
    polygonLinks: polygonLinksInterface;
    analysisZoneAndSubZonesCreated: polygonFeatures;
    zoneComponents: polygonFeatures;
    selectedZoneIds: (number | undefined)[];
    listViewFilterParams: analyzerListViewFilterParams;
    listViewFiltersData: AnalyzerFilters;
    actionPerformed: boolean;
}

export type analyzerDataState = analyzerDataStateInterface;

export type analyzerStateDataTypes =
    | updateCurrentSubZoneAction
    | getLinksInPolygonAction
    | linksInPolygonsReceivedAction
    | highlightPolygonLinksAction
    | setSegmentFeaturesAction
    | highlightSegmentLinksAction
    | setPolygonFeaturesAction
    | getAllProposedAnalysisZonesAction
    | allProposedAnalysisZonesReceivedAction
    | setSelectedZonesAction
    | deleteSelectedZonesAction
    | toggleAnalysisZonesActionPerformedAction
    | copySelectedZonesAction
    | toggleFormValidatedAction
    | proposedZoneIdAction
    | confirmAnalysisZoneToggleAction
    | isAnalysisZoneCheckedAction
    | createAnalysisZoneAndSubZonesAction
    | analysisZoneAndSubZonesCreatedAction
    | getZoneComponentsAction
    | zoneComponentsReceivedAction
    | updateZoneFiltersAction
    | editAnalysisZoneAndSubZonesAction
    | analysisZoneAndSubZonesEditedAction
    | deleteZoneComponentsAction
    | clearZoneComponentsAction
    | GetDataForAnalyzerFiltersAction
    | DataForAnalyzerFiltersReceivedAction
    | SetAnalyzerFilterParamsAction
    | ResetStateAction;
